import * as React from "react";

function SearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M5 14a9 9 0 1118 0 9 9 0 01-18 0zm9-11C7.925 3 3 7.925 3 14c0 6.074 4.925 11 11 11 2.677 0 5.132-.957 7.04-2.547l6.253 6.253 1.415-1.414-6.255-6.254A10.955 10.955 0 0025 14c0-6.075-4.926-11-11-11z",
    clipRule: "evenodd"
  }));
}

export default SearchIcon;